<ng-container *ngIf="this.type!='' && this.type=='LOADING_DATA'">

    <div class="ui-g text-center">
        <div class="ui-g-12">
            <p-progressSpinner styleClass="bigger-loading" strokeWidth="6"></p-progressSpinner>
        </div>
        <div class="ui-g-12">
            <p style="font-size: larger;"> Loading Data.... </p>
        </div>
    </div>

</ng-container>


<ng-container *ngIf="this.type!='' && this.type=='POSTING_DATA'">

    <div class="ui-g text-center">
        <div class="ui-g-12">
            <p-progressSpinner styleClass="middle-loading" strokeWidth="6"></p-progressSpinner>
        </div>
        <!-- <div class="ui-g-12">
      <p style="font-size: larger;"> Loading Data.... </p>
    </div> -->
    </div>

</ng-container>


<ng-container *ngIf="this.type!='' && this.type=='SMALL_LOADER'">

    <div class="ui-g text-center">
        <div class="ui-g-12">
            <p-progressSpinner styleClass="small-loading" strokeWidth="6"></p-progressSpinner>
        </div>
        <!-- <div class="ui-g-12">
      <p style="font-size: larger;"> Loading Data.... </p>
    </div> -->
    </div>

</ng-container>
